import CtaBox from 'Components/CtaBox/CtaBox';

export default CtaBox;
